import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AppLayer } from 'app/services/layer.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { TopoCheckOutput, TopoCheckAreaIndex, TopoCheckCrevice, TopoService, TopoCheckInterLayerOutput } from 'app/services/topo.service';
import { Subscription } from 'rxjs';

export type TopoErrorType = 'gap' | 'overlap' | 'crevice';
interface TopoErrorObject {
	type: TopoErrorType;
	label: string;
	list: TopoCheckAreaIndexExt[];
	isSelectedAll?: boolean
	isExpand?: boolean;
}
export interface TopoCreviceObject {
	type: TopoErrorType;
	label: string;
	list: TopoCheckCreviceExt[];
	isExpand?: boolean;
}
export interface SelectTopoErrorData {
	type: TopoErrorType;
	topoItem: TopoCheckAreaIndexExt | TopoCheckCreviceExt;
}
export interface TopoCheckAreaIndexExt extends TopoCheckAreaIndex{
	selected?: boolean;
	coordinates?: any[];
	isGeomShow?: boolean;
}
export interface TopoCheckCreviceExt extends TopoCheckCrevice {
	isGeomShow?: boolean;
}
export type ResolveData = {
	[errorType in TopoErrorType]?: any[];
}

@Component({
	selector: 'app-edit-topo-error',
	templateUrl: './edit-topo-error.component.html',
	styleUrls: ['../edit-card/edit-card.component.css', './edit-topo-error.component.css']
})
export class EditTopoErrorComponent implements OnInit, OnChanges, OnDestroy {

// Intra
	@Input() topoCheckResultIntra: TopoCheckOutput;
	topoErrorList: TopoErrorObject[] = [
		{
			type: 'overlap',
			label: 'Overlaps',
			list: []
		}, {
			type: 'gap',
			label: 'Gaps',
			list: []
		}
	];
	creviceObj: TopoCreviceObject = {
		type: 'crevice',
		label: 'Crevices',
		list: []
	};

	showCreviceOnly: boolean;
	currentSelected!: TopoCheckAreaIndexExt | TopoCheckCreviceExt;

	headers: {
		prop: string;
		name: string;
	}[] = [];

// Inter
	@Input() topoCheckResultInter: TopoCheckInterLayerOutput;



	@Output() selectTopoError: EventEmitter<SelectTopoErrorData> = new EventEmitter();
	@Output() resolve: EventEmitter<ResolveData> = new EventEmitter();
	@Output() confirmCrevice: EventEmitter<any> = new EventEmitter();
	@Output() commit: EventEmitter<any> = new EventEmitter();

	showResolveBtn = true;
	showCommitBtn = false;
	disableCommitBtn: boolean;
	showToggleResolved: boolean;
	isShowResolvedLayer: boolean;
	isLayerTopologyState: boolean
	private selectedLayerSub: Subscription;

	constructor(
		private activityService: ActivityService,
		private mapLayerService: MainDataMapLayersService,
		private mapService: MainDataMapService,
		private topoService: TopoService
	) { }

	clickResolve() {
		// TODO
		const data: ResolveData = {};
		this.topoErrorList.forEach(o => {
			const selected = o.list.filter(topo => topo.selected).map(topo => topo.topo_gid);
			if (selected.length) {
				data[o.type] = selected;
			}
		});
		this.resolve.emit(data);
	}
	clickConfirm() {
		this.confirmCrevice.emit();
	}
	clickCommit() {
		this.disableCommitBtn = true;
		setTimeout(() => this.disableCommitBtn = false, 3000);
		this.commit.emit();
	}

	toggleTopoErrorExpand(topo: TopoErrorObject) {
		topo.isExpand = !topo.isExpand;
	}

// Intra Check Section
	private onTopoCheckIntraChange() {
		if (!this.topoCheckResultIntra) {
			this.clearTopoChecks();
			return;
		}
		const result = this.topoCheckResultIntra;
		const overlap = this.topoErrorList.find(t => t.type === 'overlap');
		overlap.list = result.overlap || [];
		overlap.list.forEach(i => {
			const topo = result.topologized_areas.find(t => t.gid === i.topo_gid);
			i.coordinates = topo.geom.coordinates;
		})
		const gap = this.topoErrorList.find(t => t.type === 'gap');
		gap.list = this.topoCheckResultIntra.gap || [];
		gap.list.forEach(i => {
			const topo = result.topologized_areas.find(t => t.gid === i.topo_gid);
			i.coordinates = topo.geom.coordinates;
		});
		this.creviceObj.list = this.topoCheckResultIntra.crevice || [];
		this.creviceObj.list.forEach(i => i.isGeomShow = true);

		this.showCreviceOnly = this.topoService.checkShowCreviceOnly(this.topoCheckResultIntra);
	}
	private clearTopoChecks() {
		this.topoErrorList.forEach(t => t.list = []);
		this.creviceObj.list = [];
	}

// Inter Check Section
	private onTopoCheckInterChange() {}


	toggleCheckAll(topo: TopoErrorObject) {
		topo.list.forEach(i => i.selected = topo.isSelectedAll);
	}
	clickRow(item: TopoCheckAreaIndexExt | TopoCheckCreviceExt, topo: TopoErrorObject | TopoCreviceObject) {
		this.currentSelected = item;
		this.selectTopoError.emit({
			type: topo.type,
			topoItem: item
		});
	}
	// onSelectRow(e, topo: TopoErrorObject) {
	// 	this.selectTopoError.emit({
	// 		type: topo.type,
	// 		topoError: e.selected[0]
	// 	});
	// }
	onTableContextmenu(e, topo: TopoErrorObject) {}

	toggleResolved() {
		let resolvedLayerVisib = this.isShowResolvedLayer;
		const topoErrorLayer = this.mapService.map.addedLayers[this.mapLayerService.topoErrorLayerName];
		const resolvedLayer = this.mapService.map.addedLayers[this.mapLayerService.topoResolvedLayerName];
		resolvedLayer.setVisible(resolvedLayerVisib);
		topoErrorLayer.setVisible(!resolvedLayerVisib);
	}

	test() {
		console.log('resize')
	}
	ngOnInit() {
		this.headers = [
			// {
			// 	prop: 'checkBox',
			// 	name: ' '
			// },
			{
				prop: 'expandToggle',
				name: ' '
			},
			{
				prop: 'originGid',
				name: 'ori_gid'
			}
			// ,{
			// 	prop: 'size',
			// 	name: 'Size (sq M)'
			// }
		];
		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(data => {
			const layer = data.layer;
			if (layer) {
				this.isLayerTopologyState = layer.state.name === 'TOPOLOGY';

				if (this.isLayerTopologyState) {
					this.showResolveBtn = false;
					this.showCommitBtn = true;
					this.showToggleResolved = true;
					// Set topoError layer to visible
					const topoErrorLayer = this.mapService.map.addedLayers[this.mapLayerService.topoErrorLayerName];
					const resolvedLayer = this.mapService.map.addedLayers[this.mapLayerService.topoResolvedLayerName];
					if (!topoErrorLayer.getVisible()) {
						topoErrorLayer.setVisible(true);
					}
					if (resolvedLayer.getVisible()) {
						resolvedLayer.setVisible(false);
					}
				}
			}
		});
		// Set visibility
		const resolvedLayer = this.mapService.map.addedLayers[this.mapLayerService.topoResolvedLayerName];
		this.isShowResolvedLayer = resolvedLayer.getVisible();
		this.toggleResolved();
		// this.columns.push(this.tableService.setNewColumn('operation', ' ', {
		// 	cellTemplate: this.operationCellTempl,
		// 	width: 30
		// }));
		// this.columns.push(this.tableService.setNewColumn('gids', 'ID(s)'));
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.topoCheckResultIntra) {
			this.onTopoCheckIntraChange();
		}
		if (changes.topoCheckResultInter) {
			this.onTopoCheckInterChange();
		}
	}
	ngOnDestroy(): void {
		this.selectedLayerSub.unsubscribe();
	}
}
